import { render, staticRenderFns } from "./SidebarEmailPanel.vue?vue&type=template&id=fc15cc44&scoped=true&"
import script from "./SidebarEmailPanel.vue?vue&type=script&lang=js&"
export * from "./SidebarEmailPanel.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEmailPanel.vue?vue&type=style&index=0&id=fc15cc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc15cc44",
  null
  
)

export default component.exports